module.exports = __webpack_public_path__ + "img/category-popular-hover.968424e7.png";